import { Button, Group, Space, Textarea, TextInput } from "@mantine/core";
import { extractTextInputPropertiesFromFormSchema } from "@/utils/form";
import useTipoDeJogadaForm from "./useTipoDeJogadaForm";
import { TTipoDeJogadaForm } from "../../firestore";
import tipoDeJogadaSchema from "../../schema/tipo-de-jogada-schema";
// prettier-ignore
const TipoDeJogadaForm = ({
  tipoDeJogada,
  onSuccess
}: {
  tipoDeJogada: TTipoDeJogadaForm;
  onSuccess: () => void;
}) => {
  const { getInputProps, onSubmit, isLoading } = useTipoDeJogadaForm(tipoDeJogada, {
    onSuccess
  });
  const fieldsDescriptor = tipoDeJogadaSchema.describe();

  return (
    <form onSubmit={onSubmit}>
      <TextInput
        mt="md"
        {...getInputProps("nome")}
        {...extractTextInputPropertiesFromFormSchema(fieldsDescriptor, "nome")}
        label={"Nome"}
      />
      <Space h="lg" />
      <Textarea
        autosize
        minRows={5}
        {...getInputProps("descricao")}
        {...extractTextInputPropertiesFromFormSchema(fieldsDescriptor, "descricao")}
        label={"Descrição"}
      />
      <Space h="xl" />
      <Group justify="flex-end">
        <Button type="submit" variant="filled" loading={isLoading}>
          Salvar
        </Button>
      </Group>
    </form>
  );
};

export default TipoDeJogadaForm;
